import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "avanti_cart";

export function CartProvider({ children }) {
  const [lines, setLines] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(lines));
  }, [lines]);

  const add = (line) => setLines((p) => [...p, { ...line, key: `${Date.now()}-${Math.random()}` }]);
  const remove = (key) => setLines((p) => p.filter((l) => l.key !== key));
  const setQty = (key, qty) =>
    setLines((p) => p.map((l) => (l.key === key ? { ...l, qty: Math.max(1, Math.min(20, qty)) } : l)));
  const clear = () => setLines([]);

  const total = lines.reduce((s, l) => s + l.unit * l.qty, 0);
  const count = lines.reduce((s, l) => s + l.qty, 0);

  return <CartCtx.Provider value={{ lines, add, remove, setQty, clear, total, count }}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
